export default {"src":"/_next/static/media/powerUpSolid_72.c6752b8a.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};